import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { useControlledSwr } from '../../../hooks/use-controlled-swr';
import { useFetch } from '../../../hooks/use-fetch';
import { RequestMethodsEnum } from '../../../hooks/use-fetch/types';
import useUser from '../../../hooks/use-user';
import { EmailFooterDataInterface, EmailFooterDataListInterface } from '../types/email-footer-interface';
export const useEmailFooterData = () => {
  const $ = _c(10);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher,
    isFetching
  } = useFetch(t0);
  let t1;
  if ($[1] !== user) {
    t1 = () => user && ["/api/dashboard/mailing-service/email-footer"];
    $[1] = user;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data: emailFooterData,
    mutate
  } = useControlledSwr(t1, fetcher);
  let t2;
  if ($[3] !== emailFooterData) {
    bb0: {
      if (!emailFooterData?.items?.length) {
        t2 = null;
        break bb0;
      }
      const validItems = emailFooterData.items.filter(_temp);
      if (validItems.length === 0) {
        t2 = null;
        break bb0;
      }
      t2 = validItems.reduce(_temp2, validItems[0]);
    }
    $[3] = emailFooterData;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const lastUpdatedFooter = t2;
  let t3;
  if ($[5] !== emailFooterData || $[6] !== isFetching || $[7] !== lastUpdatedFooter || $[8] !== mutate) {
    t3 = {
      emailFooterData,
      isFetchingEmailFooterData: isFetching,
      lastUpdatedFooter,
      mutateEmailFooterData: mutate
    };
    $[5] = emailFooterData;
    $[6] = isFetching;
    $[7] = lastUpdatedFooter;
    $[8] = mutate;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
function _temp(item) {
  return item.updatedAt !== null;
}
function _temp2(latest, item_0) {
  if (!latest.updatedAt) {
    return item_0;
  }
  return new Date(item_0.updatedAt) > new Date(latest.updatedAt) ? item_0 : latest;
}